import React from "react";
import { FiTarget } from "react-icons/fi";
import MiniGamePage from "./MiniGamePage";
import { spinWheelApi } from "../../utils/miniGameApi";

const SpinWheelGame = () => (
  <MiniGamePage
    title="Lucky Spin Wheel"
    selfLabel="Spin Wheel"
    description="Manage wheel slice values, prize probabilities, spin rules and audit logs."
    icon={FiTarget}
    api={spinWheelApi}
    scoreLabel="Slice Points"
    switchTo={[
      { to: "/tap-game", label: "Tap Game" },
      { to: "/boom-cards-game", label: "Boom Cards" },
      { to: "/game-2048", label: "2048" },
      { to: "/fruit-cut", label: "Fruit Cut" },
      { to: "/slots-game", label: "Slot Machine" },
    ]}
  />
);

export default SpinWheelGame;
